import { render } from "./BasicInfoCard.vue?vue&type=template&id=e720de6a"
import script from "./BasicInfoCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__